import { DeleteOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { Button, Modal, message, Tooltip } from "antd";
import { useDeleteEligibleDebtorsForGroupMutation } from "features/mergeGroups/mergeDebtorsAPI";
import { PERMISSIONS } from "features/permissions";
import useAuthorizations from "features/permissions/hooks/useAuthorizations";
import { useMemo } from "react";

const { confirm } = Modal;

export function MergeDebtorsBulkActions({ dataSource = [] }) {
  const [deleteEligibleDebtors] = useDeleteEligibleDebtorsForGroupMutation();

  const {
    data: { [PERMISSIONS.DEBTOR_MERGE_GROUP__DELETE]: isMergeGroupDeleteAuthorized },
  } = useAuthorizations();

  const actionItems = useMemo(
    () => [
      {
        key: "delete",
        label: "Delete Matches",
        icon: <DeleteOutlined />,
        actionHandler: async () => {
          const deletePromises = dataSource.map((record) =>
            deleteEligibleDebtors({ mergeEligibleDebtorsId: record.id }).unwrap(),
          );
          await Promise.all(deletePromises);
        },
        isVisible: isMergeGroupDeleteAuthorized,
        disabled: dataSource.length === 0,
      },
    ],
    [dataSource, deleteEligibleDebtors, isMergeGroupDeleteAuthorized],
  );

  const handleOk = (item, key) => {
    const keyTitles = {
      delete: `Are you sure you want to delete ${dataSource.length} selected match(es)? Deleted matches cannot be recovered.`,
    };

    confirm({
      title: keyTitles[key],
      icon: <ExclamationCircleOutlined />,
      async onOk() {
        try {
          await item.actionHandler();
          message.success(
            `${dataSource.length} ${
              key === "merge" ? "merge(s)" : "match(es)"
            } completed successfully!`,
          );
        } catch (error) {
          message.error(
            `Failed to ${key} ${key === "merge" ? "debtors" : "matches"}. Please try again later.`,
          );
        }
      },
    });
  };

  const itemsToDisplay = actionItems.filter((item) => item.isVisible);
  if (itemsToDisplay.length === 0) {
    return null;
  }

  return actionItems
    ?.filter((item) => item.isVisible)
    ?.map((item) => (
      <Tooltip key={item.key} title={item.label}>
        <Button
          shape="circle"
          icon={item.icon}
          type="text"
          disabled={item.disabled}
          onClick={() => handleOk(item, item.key)}
        />
      </Tooltip>
    ));
}
